import { useEffect, useState } from 'react';

import { servGetmetricas } from '../../servicos/metrica';

function SelectMetricaIndicadorControlled({ id, value, onChange }) {

    const [metricas, setMetricas] = useState([])

    useEffect(() => {
        getMetricas()
    }, []);

    const getMetricas = async () => {
        try {
            const metricasDaApi = await servGetmetricas()
            setMetricas(metricasDaApi)
        } catch (erro) {
            console.log(erro);
        }
    }

    return (
        <>
            {metricas ? (
                <div className="">
                    <select
                        className="form-control-sm mw-100"
                        id={id}
                        value={value || ''}
                        name="status"
                        onChange={(e) => onChange(Number(e.target.value) || null)}
                    >
                        <option value="">Selecione uma opção</option>
                        {metricas.map((metrica) => (
                            <option key={metrica.id} value={metrica.id}>
                                {metrica.codigo} - {metrica.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <>
                    <p>Carregando informações das métricas...</p>
                </>
            )}
        </>
    )
}

export default SelectMetricaIndicadorControlled